import React, {useContext, useEffect, useRef, useState} from 'react';
import './searchProductSite.css'
import {Context} from "../../index";
import {observer} from "mobx-react-lite";
import OneProductCart from "../catalog/OneProductCart";
import {productSearchBound} from "../../http/publicSearchApi";
import {useLocation} from "react-router-dom";
import Spiner from "../administrator/spiner/Spiner";


const SearchProductSite = observer(() => {

    const {settings} = useContext(Context)
    const [reduceArraySerch, setReduceArraySerch] = useState([])
    const [spinerSearch, setSpinerSearch] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const [searchError, setSearchError] = useState(false);
    const [retry, setRetry] = useState(0);
    const epoch = useRef(0);
    const moreOwner = useRef(null);

    const limit = 21;
    const [nextOffsetSearch, setNextOffsetSearch] = useState(null);

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const query = (params.get("query") || '').trim();
    const currentQuery = useRef(query);
    currentQuery.current = query;
    
    useEffect(() => {
        const requestEpoch = ++epoch.current;
        const isCurrent = () => epoch.current === requestEpoch && currentQuery.current === query;
        moreOwner.current = null;
        window.scrollTo(0, 0);
        setSpinerSearch(true);
        setReduceArraySerch([]);
        setNextOffsetSearch(null);
        setLoadingMore(false);
        setSearchError(false);

        if (!query) {
            setSpinerSearch(false);
            return () => {
                if (epoch.current === requestEpoch) epoch.current += 1;
            };
        }

        productSearchBound(query, limit, 0).then(response => {
            if (!isCurrent()) return;
            setReduceArraySerch(response.rows);
            setNextOffsetSearch(response.next_offset);
            settings.setSearchQuery('');
        }).catch(() => {
            if (!isCurrent()) return;
            setReduceArraySerch([]);
            setNextOffsetSearch(null);
            setSearchError(true);
        }).finally(() => {
            if (isCurrent()) setSpinerSearch(false);
        })

        return () => {
            if (epoch.current === requestEpoch) epoch.current += 1;
            moreOwner.current = null;
        };
    }, [query, retry, settings]);

    const newArrayProductSearch = () => {
        if (nextOffsetSearch === null || moreOwner.current || currentQuery.current !== query) return;
        const owner = {epoch: epoch.current, query, offset: nextOffsetSearch};
        moreOwner.current = owner;
        const isCurrent = () => moreOwner.current === owner && epoch.current === owner.epoch &&
            currentQuery.current === owner.query;
        setLoadingMore(true);
        setSearchError(false);
        productSearchBound(owner.query, limit, owner.offset).then(response => {
            if (!isCurrent()) return;
            setReduceArraySerch(currentRows => epoch.current === owner.epoch && currentQuery.current === owner.query
                ? currentRows.concat(response.rows) : currentRows);
            setNextOffsetSearch(response.next_offset);
        }).catch(() => {
            if (isCurrent()) setSearchError(true);
        }).finally(() => {
            if (!isCurrent()) return;
            moreOwner.current = null;
            setLoadingMore(false);
        })
    }

    // определяем высоту при переходе, чтобы при возврате проскролить на это же место
    const handleScroll = () => {
        settings.setScrollStatusCatalog(window.scrollY);
    };



    return (
        <div style={{marginTop:settings.headerHeight}} className={"search_page"}>
            <div className={"search_product_list"}>
                {
                    spinerSearch ?
                        <div className={"products_wrapper standart"}>
                            <Spiner/>
                        </div>
                        :
                        <div className={"products_wrapper standart"}>
                            {
                                reduceArraySerch.length != 0 && reduceArraySerch ? reduceArraySerch.map((item, index) =>
                                        <OneProductCart
                                            item={item}
                                            index={index}
                                            key={item.id}
                                            handleScroll = {e => handleScroll()}
                                            // parrent={parrent}
                                            // child={child}
                                        />
                                    )
                                    :
                                    !searchError && <div className={"non_result_search"}>По вашему запросу ничего не найдено</div>
                            }
                        </div>
                }

                {searchError && <div role="alert">
                    Не удалось загрузить результаты поиска.
                    <button type="button" onClick={() => nextOffsetSearch === null ? setRetry(value => value + 1) : newArrayProductSearch()}>
                        Повторить
                    </button>
                </div>}
                {
                    nextOffsetSearch !== null ?
                        <button type="button" disabled={loadingMore}
                            onClick={() => newArrayProductSearch()}
                            className={"download_more_products"}>
                            {loadingMore ? 'Загружаем…' : 'Загрузить ещё'}
                        </button>
                        : ""
                }
            </div>

        </div>
    );
});

export default SearchProductSite;
